import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useIsWorkWithFriendsV2Enabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.WORK_WITH_FRIENDS_V2, {
    defaultValue: false,
  });
}
